import { useEffect, useRef } from "react";

import PageSeo from "@/components/PageSeo";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import HeroSection from "@/components/sections/HeroSection";
import { aiCareerAdvantageThankYouPageContent } from "@/content/pages/aiCareerAdvantageThankYouPage";
import { getStripeCheckoutSessionId, trackPurchase } from "@/lib/conversionTracking";

const AiCareerAdvantageThankYouPage = () => {
  const hasTrackedPurchase = useRef(false);

  useEffect(() => {
    if (hasTrackedPurchase.current) {
      return;
    }

    const didTrackPurchase = trackPurchase({
      product: "bundle",
      location: "bundle_thank_you",
      transactionId: getStripeCheckoutSessionId(window.location.search),
    });

    if (didTrackPurchase) {
      hasTrackedPurchase.current = true;
    }
  }, []);

  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={aiCareerAdvantageThankYouPageContent.seo} />
      <HeroSection content={aiCareerAdvantageThankYouPageContent.hero} dataTestId="bundle-thank-you-hero" />
      <CtaBannerSection content={aiCareerAdvantageThankYouPageContent.finalCta} dataTestId="bundle-thank-you-cta" />
    </div>
  );
};

export default AiCareerAdvantageThankYouPage;
